/**
 * Centralized route registry.
 * Add every new page here — the Sitemap page reads this automatically.
 * Routes marked `hidden` won't appear on the sitemap (e.g. 404, dynamic detail pages).
 */

export interface SiteRoute {
  path: string;
  label: string;
  group: string;
  hidden?: boolean;
}

export const siteRoutes: SiteRoute[] = [
  { path: "/", label: "Home", group: "Main Pages" },
  { path: "/about", label: "About", group: "Main Pages" },
  { path: "/team", label: "Team", group: "Main Pages" },
  { path: "/events", label: "Events", group: "Main Pages" },
  {
    path: "/events/home-equity-line-of-credit-workshop",
    label: "Home Equity Line of Credit Workshop",
    group: "Resources",
  },
  { path: "/work-with-us", label: "Work With Us", group: "Main Pages" },
  { path: "/listings", label: "Listings", group: "Main Pages" },
  { path: "/consultation", label: "Book a Consultation", group: "Main Pages" },
  { path: "/buy-a-home", label: "Buy a Home", group: "Services" },
  { path: "/sell-your-home", label: "Sell Your Home", group: "Services" },
  { path: "/invest", label: "Invest in Real Estate", group: "Services" },
  { path: "/interior-design", label: "Interior Design", group: "Services" },
  { path: "/dominican-republic", label: "Dominican Republic Investing", group: "Dominican Republic" },
  { path: "/property-preparation", label: "Property Preparation", group: "Property Preparation" },
  { path: "/painting", label: "Painting", group: "Property Preparation" },
  { path: "/carpentry", label: "Carpentry", group: "Property Preparation" },
  { path: "/cleaning", label: "Cleaning", group: "Property Preparation" },
  { path: "/resources", label: "Resources", group: "Resources" },
  { path: "/resources/guides", label: "Guides", group: "Resources" },
  { path: "/blog", label: "Blog", group: "Resources" },
  { path: "/success-stories", label: "Success Stories", group: "Resources" },
  { path: "/faq", label: "FAQ", group: "Resources" },
  { path: "/privacy-policy", label: "Privacy Policy", group: "Legal" },
  { path: "/terms-of-service", label: "Terms of Service", group: "Legal" },
  { path: "/sitemap", label: "Sitemap", group: "Legal" },
  { path: "/listing/:slug", label: "Listing Detail", group: "Internal", hidden: true },
  { path: "/community-impact", label: "Community Impact", group: "Main Pages" },
  { path: "/team/esther-summersett", label: "Esther Summersett", group: "Internal" },
  { path: "/team/jessiree-pena", label: "Jessiree Peña", group: "Internal" },
  { path: "/dominican-republic-investing/properties", label: "Properties", group: "Dominican Republic" },
  { path: "/dominican-republic-investing/properties/:slug", label: "DR Property Detail", group: "Internal", hidden: true },
  { path: "/style-guide", label: "Style Guide", group: "Internal" },
];

/** Group order for display on the sitemap */
export const sitemapGroupOrder = [
  "Main Pages",
  "Services",
  "Dominican Republic",
  "Property Preparation",
  "Resources",
  "Legal",
  "Internal",
];

/** Returns visible routes grouped for the sitemap */
export function getSitemapGroups() {
  const visible = siteRoutes.filter((r) => !r.hidden);
  const grouped = new Map<string, SiteRoute[]>();

  for (const route of visible) {
    const list = grouped.get(route.group) || [];
    list.push(route);
    grouped.set(route.group, list);
  }

  return sitemapGroupOrder
    .filter((g) => grouped.has(g))
    .map((g) => ({ title: g, links: grouped.get(g)! }));
}
